import { merge } from 'es-toolkit/compat';
import type { ConfigFilter, ModuleCommonProps } from '../../_configs/types';
import type { Filter } from '../../_types/Car';
import filterMap from '../../modules/fahrzeugsuche/filter/maps/filterMap';
import checkUndefinedNullOrEmpty from '../../utils/tools/checkUndefinedNullOrEmpty';

export default function removeNonFilterPropsFromFilter(
    obj: Filter,
    useFirmenFilter: boolean,
    forcedFilter: ModuleCommonProps['forcedFilter']
): Omit<Filter, 'ignoreFirma' | 'ignoreStandort' | 'nfzHersteller' | 'NFZ' | 'order' | 'moreCars' | 'pageSize' | 'sort' | 'StandortQuelle'> {
    const filterElements = filterMap(useFirmenFilter);

    const newFilter = merge({}, obj);
    delete newFilter.ignoreFirma;
    delete newFilter.ignoreStandort;
    delete newFilter.nfzHersteller;
    delete newFilter.NFZ;
    delete newFilter.moreCars;
    delete newFilter.pageSize;
    delete newFilter.order;
    delete newFilter.sort;
    delete newFilter.StandortQuelle;

    if (!checkUndefinedNullOrEmpty(forcedFilter)) {
        Object?.keys(forcedFilter)?.map((filterKey) => {
            const filterElementKey = Object.keys(filterElements)?.find((key) => filterElements?.[key]?.filterKey === filterKey) as ConfigFilter;
            const filterElement = filterElements?.[filterElementKey];
            delete newFilter[filterElement?.filterKey];
        });
    }

    return newFilter;
}
